// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    PutAsrFilterConfigByIdMultilingualParam,
    PutAsrFilterConfigByIdMultilingualBody,
    BaseResponseVoid,
    DeleteAsrFilterConfigByIdMultilingualParam,
} from '../../../types';

/**
 * updateMultilingual
 *
 * @export
 * @tags asr-filter-config-controller
 * @link [PUT] /asr-filter-config/{id}/multilingual
 * @param id
 */
export function putAsrFilterConfigByIdMultilingual(
    data: PutAsrFilterConfigByIdMultilingualBody,
    options: ApiOptions<PutAsrFilterConfigByIdMultilingualParam, never> & {
        segments: PutAsrFilterConfigByIdMultilingualParam;
    }
): Promise<BaseResponseVoid> {
    return request<
        PutAsrFilterConfigByIdMultilingualBody,
        PutAsrFilterConfigByIdMultilingualParam,
        never
    >('/asr-filter-config/{id}/multilingual', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName: 'putAsrFilterConfigByIdMultilingual',
    });
}

/**
 * deleteMultilingual
 *
 * @export
 * @tags asr-filter-config-controller
 * @link [DELETE] /asr-filter-config/{id}/multilingual
 * @param id
 */
export function deleteAsrFilterConfigByIdMultilingual(
    options: ApiOptions<DeleteAsrFilterConfigByIdMultilingualParam, never> & {
        segments: DeleteAsrFilterConfigByIdMultilingualParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, DeleteAsrFilterConfigByIdMultilingualParam, never>(
        '/asr-filter-config/{id}/multilingual',
        {
            ...options,
            method: 'delete',
            __$requestCalleeName: 'deleteAsrFilterConfigByIdMultilingual',
        }
    );
}

export const meta = [
    {
        tags: ['asr-filter-config-controller'],
        path: '/asr-filter-config/{id}/multilingual',
        method: 'put',
    },
    {
        tags: ['asr-filter-config-controller'],
        path: '/asr-filter-config/{id}/multilingual',
        method: 'delete',
    },
];
